import React, { useEffect, useId } from "react";
import {
  SkeletonComponent,
  SkeletonModel,
} from "@syncfusion/ej2-react-notifications";
import { createSpinner, showSpinner } from "@syncfusion/ej2-react-popups";

export interface LoadingV2Props extends SkeletonModel {
  className?: string;
  loadingType?: "skeleton" | "spinner";
}

export const LoadingV2: React.FC<LoadingV2Props> = ({
  width,
  height = "400px",
  shape = "Rectangle",
  className,
  loadingType = "skeleton",
}) => {
  // Create unique id for the container
  const containerId = useId();

  useEffect(() => {
    if (loadingType === "spinner") {
      createSpinner({
        // Specify the target for the spinner to show
        target: document.getElementById(containerId) as HTMLElement,
        width: width || "50px",
        type: "Tailwind"
      });
      showSpinner(document.getElementById(containerId) as HTMLElement);
    }
  }, []);
  return (
    <div className={className} >
      {loadingType === "skeleton" ? (
        <SkeletonComponent width={width || "100%"} height={height} shape={shape} />
      ) : (
        <div className="spinner-container" id={containerId} />
      )}
    </div>
  );
};
